import gql from 'graphql-tag';

export const createCompany = gql`
  mutation createCompany($input: CompanyDataTableInput) {
    createCompany(input: $input) {
      id
      name
      abbreviation
      enabled
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
`;
